import { useState } from 'react';
import { Alert, Platform } from 'react-native';

import { useAuth } from '../../../contexts/AuthContext';
import { useOAuth } from '../../../contexts/OAuthProvider';
import { useSampleData } from '../../../contexts/SampleDataContext';
import { finishAuthNavigation } from '../../../core/navigation/navigationRef';

function showGoogleError(message: string) {
  if (Platform.OS === ('web' as typeof Platform.OS)) {
    // RN Web Alert is easy to miss; surface clearly in the browser.
    // eslint-disable-next-line no-alert
    window.alert(`Google Sign-In Failed\n\n${message}`);
    return;
  }
  Alert.alert('Google Sign-In Failed', message);
}

export function useGoogleLogin() {
  const { login } = useAuth();
  const { authenticate } = useOAuth();
  const { exitSampleMode, markPreviewSeen } = useSampleData();
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const handleGoogleLogin = async () => {
    setIsGoogleLoading(true);
    try {
      const result = await authenticate();
      await login(
        {
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
        },
        result.user,
      );
      exitSampleMode();
      await markPreviewSeen();
      finishAuthNavigation();
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to sign in with Google';
      if (!message.toLowerCase().includes('redirecting')) {
        console.error('[useGoogleLogin] ❌', message, error);
        showGoogleError(message);
      }
    } finally {
      setIsGoogleLoading(false);
    }
  };

  return { handleGoogleLogin, isGoogleLoading };
}
